import { Injectable } from 'angular-ts-decorators';

import { SettingsManager } from './settings-manager';
import { Version } from './version';

/**
 * Service
 */
@Injectable('softwear')
export class Softwear {
  public readonly settings: any;
  public readonly version: string;

  constructor(
    $window: ng.IWindowService,
    settingsManager: SettingsManager,
    version: Version,
  ) {
    'ngInject';

    this.settings = settingsManager.settings;
    this.version = version;

    $window.softwear7 = this;
  }
}
